module.exports = __webpack_public_path__ + "static/media/continuousDiscourse_L.589c739.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/calibration/continuousDiscourse_L.mp3
// module id = ZYeF
// module chunks = 1